import React, { useState, useEffect } from "react";
import SideBar from "../SideBar";
import axiosClient from "../../axios";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import CSVDownload from "../CSVDownload";
// import loaderimg from "../assets/images/loader.gif";
import loaderimg from "../../assets/images/loader.gif";
import { dateConvert } from "../../dateConverter";
import { useNavigate } from "react-router-dom";
import "../../assets/css/userTable.css";
import Pagination from "../Pagination";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UserUploadCsv = () => {
  const [totalPage, setTotalPage] = useState(0);
  const [data, setData] = useState([]);
  const [filterInfo, setFilterInfo] = useState({
    page: 0,
    limit: 100,
  });
  let navigate = useNavigate();
  const [bulkData, setBulkData] = useState([]);
  const [bulkPopup, setBulkPopup] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);
  const [loader, setLoader] = useState(false);
  const [csvDate, setCsvDate] = useState("");
  const [beforeData, setBeforeData] = useState("true");
  const [missingData, setMissingData] = useState([]);

  const [searchBy, setSearchBy] = useState(1);

  // const [partnerEarning, setPartnerEarning] = useState([]);
  // const [partnerEarningPopup, setPartnerEarningPopup] = useState(false);
  // const [partners, setPartners] = useState([]);

  // const [userEarningPopup, setUserEarningPopup] = useState(false);
  // const [userEarning, setUserEarning] = useState([]);

  // const [date, setDate] = useState({
  //   start: null,
  //   end: null,
  // });

  // console.log("partners data", partners)

  // Helper function to read file as text
  const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = reject;
      reader.readAsText(file);
    });
  };

  const handleBulkCsv = async (event) => {
    setLoader(true);
    try {
      setDataUpdated(false);
      const file = event.target.files[0];
      if (!file) return;
      const text = await readFileAsText(file); // Await file reading
      // Expected headers
      const expectedHeaders = ["emailId", "phoneNumber", "userId"];
      const fileHeaders = text
        .split("\n")[0]
        .split(",")
        .map((header) => header.trim());
      // Validate headers
      if (
        !expectedHeaders.every((header, index) => header === fileHeaders[index])
      ) {
        alert("Invalid CSV Format: Headers should be 'emailId, phoneNumber'");
        return;
      }
      const rows = text.split("\n").slice(1); // Remove header

      const formattedData = rows
        .map((row) => row.split(",")) // Split by comma
        .filter((cols) => cols.length >= 2) // Ensure valid rows
        .map(([emailId = "", phoneNumber = "", userId = ""]) => ({
          emailId: emailId.trim(),
          phoneNumber: phoneNumber.trim(),
          userId: userId.trim(),
        }));

      if (formattedData.length === 0) {
        alert("Invalid CSV Format");
        return;
      }
      setBulkData(formattedData);
      setBulkPopup(true);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoader(false);
    }
  };

  const handleMisedCsvData = (filerterData) => {
    const missingData = bulkData.filter(
      (bulkItem) =>
        !filerterData.some(
          (filterItem) => filterItem.emailId === bulkItem.emailId
        )
    );
    setMissingData(missingData);
  };

  const handleBulkPopup = () => {
    setBulkPopup(!bulkPopup);
    // setBulkData([]);
    setDataUpdated(false);
  };

  // const handlePartnerRevenuePopup = () => {
  //   setPartnerEarningPopup(false);
  //   setUserEarningPopup(false);
  // };

  const handleUploadedCsv = async () => {

    if(!csvDate){
      alert("Please Provide Date");
      return;
    }
    let userData = {
      // s_date: date?.start ? dateConvert(date?.start) : null,
      // e_date: date?.end ? dateConvert(date?.end) : null,
      SelectedDate: csvDate ? dateConvert(csvDate) : null,
      bulkData: bulkData,
      beforeData: beforeData,
      searchBy: searchBy,
    };

    setLoader(true);
    await axiosClient
      .post(`/user-uploaded-csv-data`, userData)
      .then((res) => {
        setLoader(false);
        setData(res.data.response);
        setTotalPage(res.data.response.length);
        setDataUpdated(true);
        setBulkPopup(false);

        handleMisedCsvData(res.data.response);
      })
      .catch((err) => {
        alert(err.response.data.messae);
        setLoader(false);
        setDataUpdated(true);
        setBulkPopup(false);
      });
  };

  // const getPartnerEarning = async (users) => {
  //   let userids = [];
  //   userids = users.map((user) => user._id);
  //   // console.log("userids", userids)

  //   if (userids.length === 0) {
  //     alert("Please Provide  users");
  //     return;
  //   }

  //   let userData = {
  //     SelectedDate: csvDate ? dateConvert(csvDate) : "",
  //     // s_date: date?.start ? dateConvert(date?.start) : null,
  //     // e_date: date?.end ? dateConvert(date?.end) : null,
  //     userids: userids,
  //     beforeData: beforeData,
  //   };

  //   setLoader(true);
  //   await axiosClient
  //     .post(`/get-partner-earning`, userData)
  //     .then((res) => {
  //       setLoader(false);

  //       console.log("res =========>", res);
  //       setPartnerEarning(res?.data?.response);
  //       setPartnerEarningPopup(true);
  //     })
  //     .catch((err) => {
  //       alert(err.response.data.messae);
  //       setLoader(false);
  //     })
  //     .finally(() => {
  //       setLoader(false);
  //     });
  // };

  // const getUserEarning = async (users) => {
  //   let userids = [];
  //   userids = users.map((user) => user._id);

  //   if (userids.length === 0) {
  //     alert("Please Provide  users");
  //     return;
  //   }

  //   let userData = {
  //     SelectedDate: csvDate ? dateConvert(csvDate) : "",
  //     // s_date: date?.start ? dateConvert(date?.start) : null,
  //     // e_date: date?.end ? dateConvert(date?.end) : null,
  //     userids: userids,
  //     beforeData: beforeData,
  //   };

  //   setLoader(true);
  //   await axiosClient
  //     .post(`/get-user-earning`, userData)
  //     .then((res) => {
  //       setLoader(false);

  //       console.log("res =========>", res);
  //       setUserEarning(res?.data?.response);
  //       setUserEarningPopup(true);
  //     })
  //     .catch((err) => {
  //       alert(err.response.data.messae);
  //       setLoader(false);
  //     })
  //     .finally(() => {
  //       setLoader(false);
  //     });
  // };

  // const getPartners = () => {

  //     setLoader(true);

  //     axiosClient
  //         .get("/allPartners")
  //         .then((res) => setPartners(res.data.response))
  //         .catch((error) =>
  //             console.log(error)
  //         ).finally(() => setLoader(false))
  // }

  // let getPartnerName = (partnerId) => {
  //   console.log("partnerId", partnerId);
  //   let partner = partners.find((partner) => partner._id == partnerId);
  //   return partner?.name;
  // };

  const handleDownloadCsv = (data, name) => {
    try {
      const dataToExport = data.map((val, key) => ({
        "Email Id": val?.emailId,
        "Phone Number": val?.phoneNumber,
        last_login_at: val?.last_login_at,
        userId: val?._id,
      }));
      CSVDownload(dataToExport, name);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  //pagination for csv data
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // Adjust this value as needed
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = bulkData.slice(indexOfFirstItem, indexOfLastItem);

  //pagination  for partner earning popupo

  // const [page, setPage] = useState(1);
  // const pageRow = 100; // Adjust this value as needed
  // const lastIndex = page * pageRow;
  // const firstIndex = lastIndex - pageRow;
  // const newItem = partnerEarning.slice(firstIndex, lastIndex);

  // pagination for user earning
  // const [userpage, setUserPage] = useState(1);
  // const userpageRow = 100; // Adjust this value as needed
  // const userlastIndex = userpage * userpageRow;
  // const userfirstIndex = userlastIndex - userpageRow;
  // const usernewItem = userEarning.slice(userfirstIndex, userlastIndex);

  // const usersPartnerEarning = (data) => {
  //   let totolEarning = data.reduce((total, item) => total + item.revenue, 0);
  //   return totolEarning;
  // };
  // const ourPartnerEarning = (data) => {
  //   let totalAmount = data.reduce((total, item) => total + item.amount, 0);
  //   return totalAmount;
  // };

  // const handViewPartnerEarning = (val) => {
  //   const userids = data.map((user) => user._id);
  //   if (userids.length === 0) {
  //     alert("Please provide users");
  //     return;
  //   }
  //   const s_date = encodeURIComponent(csvDate);
  //   const encodedUserIds = encodeURIComponent(userids.join(","));
  //   const encodedBeforeData = encodeURIComponent(beforeData);
  //   window.open(
  //     `/uploadCsv-partnerEarning-users/${val?._id}?start=${s_date}&userids=${encodedUserIds}&beforeData=${encodedBeforeData}`,
  //     "_blank"
  //   );
  // };

   const handlePartnerEarning = () => {
    const userids = data.map((user) => user._id);
    if (userids.length === 0) {
      alert("Please provide users");
      return;
    }
    if(!csvDate){
      alert("Please provide date");
      return;
    }
    const s_date = encodeURIComponent(csvDate);
    // const encodedUserIds = encodeURIComponent(userids.join(","));
    sessionStorage.setItem("userIds", JSON.stringify(userids));
    const encodedBeforeData = encodeURIComponent(beforeData);
    // window.open(
    //   `/uploadCsvPartnerEarning?start=${s_date}&userids=${encodedUserIds}&beforeData=${encodedBeforeData}`,
    //   "_blank"
    // );
     window.open(
      `/uploadCsvPartnerEarning?start=${s_date}&beforeData=${encodedBeforeData}`,
      "_blank"
    );
  };



   const handleUserEarning = () => {
    const userids = data.map((user) => user._id);
    if (userids.length === 0) {
      alert("Please provide users");
      return;
    }
    if(!csvDate){
      alert("Please provide date");
      return;
    }
    const s_date = encodeURIComponent(csvDate);
    const encodedUserIds = encodeURIComponent(userids.join(","));
    sessionStorage.setItem("userIds", JSON.stringify(userids));

    const encodedBeforeData = encodeURIComponent(beforeData);
    window.open(
      `/userEarningn?start=${s_date}&beforeData=${encodedBeforeData}`,
      "_blank"
    );
  };

  // useEffect(() => {
  //     getPartners();
  // }, [])

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"Upload User CSV"} />
      <div className="screen">
        <div className="dFlex">
          <h2 className="screenHeading catHead">User Upload Csv</h2>
        </div>

        <div className="upload-user-csv-flex">
          <div className="user-upload">
            <form>
              <input
                type={"file"}
                id="bulkdepositCsv"
                onChange={handleBulkCsv}
                accept={".csv"}
                style={{ display: "none" }}
              />
              <label htmlFor="bulkdepositCsv" className="userCsvButton">
                Upload Csv
              </label>
            </form>
          </div>

          {dataUpdated && data?.length > 0 && (
            <div
              className="csv-download"
              onClick={() => handleDownloadCsv(data, "matchedUser.csv")}
            >
              <p>DownloadCsv </p>
            </div>
          )}

          {dataUpdated && data?.length > 0 && (
            <div
              className="csv-download"
              // onClick={() => getPartnerEarning(data)}
              onClick={() => handlePartnerEarning()}
            >
              <p>Get Partner Earning </p>
            </div>
          )}



          { data?.length > 0 && (
            <div
              className="csv-download"
              onClick={() => handleUserEarning()}
            >
              <p>Get User Earning </p>
            </div>
          )}

          {/* {data?.length > 0 && (
            <div className="csv-download" onClick={() => getUserEarning(data)}>
              <p>Get User Earning </p>
            </div>
          )} */}

          {missingData?.length > 0 && (
            <div
              className="csv-download"
              onClick={() =>
                handleDownloadCsv(missingData, "unmatchedUser.csv")
              }
            >
              <p>Unmatched User Csv </p>
            </div>
          )}
        </div>

        <div className="profileInfoBox table">
          {!loader ? (
            <>
              <div style={{ width: "100%" }} className="container app-body">
                {data.length > 0 ? (
                  <>
                    <div className="tabel-scrol">
                      <table id="users">
                        <thead>
                          <tr>
                            <th>S.NO.</th>
                            <th>UserName</th>
                            <th>Email Id </th>
                            <th>UserId</th>
                            <th>Phone Number</th>
                            <th style={{ width: "130px" }}>last_login_at</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.map((val, key) => (
                            <tr key={key}>
                              <td>
                                {filterInfo.limit * filterInfo.page + (key + 1)}
                              </td>
                              <td
                                className="clickabuetd"
                                onClick={() =>
                                  window.open(`/users/transaction/${val._id}`)
                                }
                              >
                                {val?.name}
                              </td>
                              <td>{val?.emailId}</td>
                              <td>{val?._id}</td>
                              <td>{val?.phoneNumber}</td>
                              <td>{val?.last_login_at}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* <div>
                      <Pagination
                        filterDataInput={filterInfo}
                        setFilterDataInput={setFilterInfo}
                        totalPage={totalPage}
                      />
                    </div> */}
                  </>
                ) : (
                  <>
                    <h4 className="h5Heading">No Data Available</h4>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="loaderImage">
                <img src={loaderimg} alt="loader" />
              </div>
            </>
          )}
        </div>
      </div>

      {/* <Dialog
        open={userEarningPopup}
        onClose={() => handlePartnerRevenuePopup()}
        TransitionComponent={Transition}
        className="dialogs bulkDialog"
      >
        <div className="bulkBox">
          {userEarning?.length > 0 ? (
            <div
              style={{ width: "100%" }}
              className="container app-body bulkTable"
            >
              <div className="tabel-scrol">
                <table id="users">
                  <thead>
                    <tr>
                      <th style={{ width: "40px" }}>S.NO.</th>
                      <th style={{ width: "75px" }}>User Name</th>
                      <th style={{ width: "130px" }}>Earning</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usernewItem.map((val, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{val?.userName}</td>
                        <td>{val?.revenue}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p>No Data to load</p>
          )}

          <div className="uploadCsv-pagination">
            <button
              onClick={() => setUserPage((prev) => Math.max(prev - 1, 1))}
              disabled={userpage === 1}
            >
              Previous
            </button>
            <button
              onClick={() =>
                setUserPage((prev) =>
                  Math.min(
                    prev + 1,
                    Math.ceil(userEarning.length / userpageRow)
                  )
                )
              }
              disabled={
                userpage === Math.ceil(userEarning.length / userpageRow)
              }
            >
              Next
            </button>
          </div>
        </div>
      </Dialog> */}

      {/* <Dialog
        open={partnerEarningPopup}
        onClose={() => handlePartnerRevenuePopup()}
        TransitionComponent={Transition}
        className="dialogs bulkDialog"
      >
        <div className="bulkBox">
          {
            <div
              style={{
                display: "flex",
                gap: "10px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              <span>
                User Earning : {usersPartnerEarning(partnerEarning).toFixed(6)}
              </span>
              <span>
                Our Earning : {ourPartnerEarning(partnerEarning).toFixed(6)}
              </span>
            </div>
          }

          {partnerEarning?.length > 0 ? (
            <div
              style={{ width: "100%" }}
              className="container app-body bulkTable"
            >
              <div className="tabel-scrol">
                <table id="users">
                  <thead>
                    <tr>
                      <th style={{ width: "40px" }}>S.NO.</th>
                      <th style={{ width: "75px" }}>Partner Name</th>
                      <th style={{ width: "130px" }}>User Earning</th>
                      <th style={{ width: "130px" }}>Our Earning</th>
                      <th style={{ width: "130px" }}>View Users</th>
                    </tr>
                  </thead>
                  <tbody>
                    {newItem.map((val, index) => (
                      <tr key={index}>
                        <td>{firstIndex + index + 1}</td>
                        <td>{val?.partnerName}</td>
                        <td>{val?.revenue}</td>
                        <td>{val?.amount}</td>
                        <td>
                          <button
                            style={{
                              width: "100px",
                              background: "#2b579a",
                              color: "white",
                              padding: "5px 0px",
                              paddingBottom: "5px",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                            

                            onClick={() => {
                              handViewPartnerEarning(val)
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p>No Data to load</p>
          )}

          <div className="uploadCsv-pagination">
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
            >
              Previous
            </button>
            <button
              onClick={() =>
                setPage((prev) =>
                  Math.min(prev + 1, Math.ceil(partnerEarning.length / pageRow))
                )
              }
              disabled={page === Math.ceil(partnerEarning.length / pageRow)}
            >
              Next
            </button>
          </div>
        </div>
      </Dialog> */}

      <Dialog
        open={bulkPopup}
        onClose={() => handleBulkPopup()}
        TransitionComponent={Transition}
        className="dialogs bulkDialog"
      >
        <div className="bulkBox">
          {/* <div
            className="strekDate-sec"
            style={{ width: "80%", marginBottom: "20px" }}
          >
            <div className="pending_earning_box">
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                sx={{ width: "100%", marginRight: "10px" }}
              >
                <DatePicker
                  label="Start Date"
                  value={date?.start}
                  onChange={(value) => {
                    setDate({ ...date, start: value });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  // maxDate={date?.end}
                />
              </LocalizationProvider>
            </div>
            <div className="pending_earning_box">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="End Date"
                  value={date?.end}
                  onChange={(value) => setDate({ ...date, end: value })}
                  renderInput={(params) => <TextField {...params} />}
                  // maxDate={date?.end}
                />
              </LocalizationProvider>
            </div>
          </div> */}

          <div className="dFlex w70">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Date"
                value={csvDate}
                onChange={(value) => setCsvDate(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </div>

          <div className="csv-upload-checkbox">
            <div className="select-before-radio">
              <span>Before Data:</span>
              <div className="user-select-befor">
                <p>Before</p>
                <input
                  type="radio"
                  name="beforeDatatrue"
                  value="true"
                  checked={beforeData == "true"}
                  onChange={(e) => setBeforeData(e.target.value)}
                />
              </div>

              <div className="user-select-befor">
                {/* Add commentMore actions */}
                <p>After</p>
                <input
                  type="radio"
                  name="beforeDatafalse"
                  value="false"
                  checked={beforeData == "false"}
                  onChange={(e) => setBeforeData(e.target.value)}
                />
              </div>
            </div>

            <div className="select-before-radio">
              <span>Search By:</span>
              <div className="user-select-befor">
                <p>Id</p>
                <input
                  type="radio"
                  name="id"
                  value="1"
                  checked={searchBy == "1"}
                  onChange={(e) => setSearchBy(e.target.value)}
                />
              </div>

              <div className="user-select-befor">
                <p>Email</p>
                <input
                  type="radio"
                  name="email"
                  value="2"
                  checked={searchBy == "2"}
                  onChange={(e) => setSearchBy(e.target.value)}
                />
              </div>

              <div className="user-select-befor">
                <p>Phone</p>
                <input
                  type="radio"
                  name="phone"
                  value="3"
                  checked={searchBy == "3"}
                  onChange={(e) => setSearchBy(e.target.value)}
                />
              </div>
            </div>
          </div>

          {bulkData.length > 0 ? (
            <div
              style={{ width: "100%" }}
              className="container app-body bulkTable"
            >
              <div className="tabel-scrol">
                <table id="users">
                  <thead>
                    <tr>
                      <th style={{ width: "40px" }}>S.NO.</th>
                      <th style={{ width: "75px" }}>User Email</th>
                      <th style={{ width: "130px" }}>Number</th>
                      <th style={{ width: "130px" }}>userId</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((val, index) => (
                      <tr key={index}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td className="clickable">{val?.emailId}</td>
                        <td>{val?.phoneNumber}</td>
                        <td>{val?.userId}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="uploadCsv-pagination">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(
                        prev + 1,
                        Math.ceil(bulkData.length / itemsPerPage)
                      )
                    )
                  }
                  disabled={
                    currentPage === Math.ceil(bulkData.length / itemsPerPage)
                  }
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p>No Data to load</p>
          )}

          <div className="user-csv-filter">
            <div
              className="bulkEdit"
              onClick={() => !loader && handleUploadedCsv()}
            >
              <p>Submit</p>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default UserUploadCsv;
